import type { ThirdPartyRestrictionLevel } from '@atlassian/search-client/search-page/types';

/**
 * Narrows the loosely-typed `permissionLevel` field that flows out of Relay
 * (`string | null | undefined`) to the strict `ThirdPartyRestrictionLevel | null` shape that
 * downstream consumers (e.g. `RestrictedLozenge`) expect. Unknown / missing values become `null`.
 */
export function toThirdPartyRestrictionLevel(
	permissionLevel: string | undefined | null,
): ThirdPartyRestrictionLevel | null {
	if (
		permissionLevel === 'public' ||
		permissionLevel === 'private' ||
		permissionLevel === 'restricted'
	) {
		return permissionLevel;
	}
	return null;
}
